<template>
  <div class="yo-widget">
    <!-- <div class="yo-header">
      <slot name="title"></slot>
    </div> -->
    <div class="yo-content">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
.yo-widget{
  position: fixed;
  top: 0px;
  left: 0px;
  width: calc(100% - 0px * 2 - 0px);
  height: calc(100% - 0px * 2 - 0px);

  background-color: white;

  border: #f73c3c solid 1px;
  overflow: hidden;
  box-shadow: 0px 0px 30px 0px rgb(238, 162, 169);
  z-index: 100000000;
}

@media screen and (min-width: 767px) {
  .yo-widget{
    top: 30px;
    left: 30px;
    border-radius: 20px;
    width: calc(100% - 30px * 2 - 20px * 2);
    height: calc(100% - 30px * 2 - 20px * 2);
  }
}
.yo-content{
  height: calc(100%);
  border-radius: 0px 0px 0px 0px;
  background-color: rgb(255, 255, 255);
  color: rgb(0, 0, 0);
}

.center-full{
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
